export default {
  USER_JUMP_COACH: '/api/user/jumpCoach',            // 跳转教练端参数

  USER_LOGOUT: '/api/user/logout',                   // 退出登录

  COMMON_SCHOOL_GET: '/api/common/school/get',            // 主键查询学校

  COMMON_GETAREA_SCHOOL_LIST: '/api/common/school/getArea/school',            // 地区查询学校

  SCHOOL_LIST: '/api/common/school/list',            // 学校列表

  GETAREA_SCHOOL: '/api/area/getArea/school',          // 获取优化省市学校接口

  SCHOOL_SENDEMAIL: '/api/common/school/sendEmail',  // 新增学校申请

  SCHOOL_LIST_ALL: '/api/common/school/list/all',  // 新增学校申请

  COMMON_GETAREA: '/api/area/getArea',              // 获取区域

  COMMON_GETGRADING_AREA: '/api/area/getGradingArea',              // 学校优化 获取省市  传 C查询,不传默认省，传了默认查下来的市

  USER_LOGON: '/api/user/login',                     // 登录

  GET_GROUPS: '/api/contest/enter/getGroups',        // 获取组别信息

  GET_SEASON_GROUP: '/api/v3/contest/group/getSeasonGroup',        // 获取活动季组别信息

  ENTER_INFO: '/api/contest/enter/find',             // 获取报名信息

  ENTER_USER_GETINFO: '/api/v3/contest/enter/user/getInfo',             // 获取报名信息（任务优化）

  ENTER_GRADES: '/api/contest/enter/grades',         // 获取年级限制

  ENTER_GETGRADEINFO: '/api/v3/contest/enter/getGradeInfo',         // 获取年级限制（报名优化）

  ENTER_POST: '/api/contest/enter/post',             // 提交报名信息

  ENTER_USER_SAVE: '/api/v3/contest/enter/user/save', // 提交报名信息(报名优化)

  ENTER_USER_GETTASKGUIDE: '/api/v3/contest/taskRelation/user/getTaskGuide', // [新增] 查询任务指引（学生端）
  ENTER_SIMPLESAVE: '/api/v3/contest/enter/user/simpleSave', // 简化报名提交（姓名/手机/邮箱）

  ENTER_TASKCOMPLETE: '/api/v3/contest/taskRelation/user/getRegisterTaskComplete', // 查询报名信息是否完善

  ENTER_USER_GETJUNMP_TASKLIST: '/api/v3/contest/taskRelation/user/getJumpPayTaskList', // 查询报名后跳转缴费任务列表(学生端)

  FILE_UPLOAD: '/api/common/upload',                 // 文件上传

  USER_INFO: '/api/user/info',                       // 获取用户信息接口

  USER_WECHAT_REGISTER: '/api/user/wechat/register',    // 微信绑定新账号注册

  USER_UPDATE: '/api/user/update',                   // 用户信息修改接口

  IDENTITY_INFO: '/api/user/identity/info',          // 获取信息修改接口

  IDENTITY_UPDATE: '/api/user/identity/update',      // 用户信息修改接口

  PASSWORD_UPDATE: '/api/user/password/update',      // 用户修改密码接口

  USER_INFO_GET: '/api/user/account/get',      // 获取用户账号接口

  USER_GRAPHCODE: '/api/user/graphcode',             // 获取图形验证码

  USER_GETSMSCODE: '/api/user/getSmsCode',           // 获取短信验证码

  VALIDATE_SMSCODE: '/api/user/validate/smscode',    // 校验短信验证码

  USER_REGISTER: '/api/user/register',               // 用户注册

  PSD_RECOVER: '/api/user/password/recover',         // 用户重新设置密码接口

  LOGIN_STATE: '/api/user/loginState',                // 查询是否登录

  LOGIN_NAME: '/api/user/loginName',                  // 查询当前登录用户

  ACCOUNT_USER_GETSMSCODE: '/api/user/getSmsCode',                  // 带图形验证码账号验证码发送

  ACCOUNT_CHANGE: '/api/user/account/change',                  // 变更账号

  PRE_PHONE: '/api/area/mobilePres/list',             // 查询区号列表

  ACOUNT_PASSWORD: '/api/user/thirdparty/info',       // 获取第三方账号密码

  WECHAT_LOGIN: '/api/user/wechat/index',             // 获取绑定微信二维码页面

  WECHAT_BIND: '/api/user/wechat/bind',               // 绑定微信

  USER_LOGIN_TICKET: '/api/user/loginByTicket',       // ticket登录

  ENTER_PINYIN: '/api/contest/enter/pinyin',      // 获取姓名的拼音

  USER_TAG_LIST: '/api/tag/list',                     // 标签查询

  USER_USER_DETAIL: '/api/user/userDetail',           // 个人主页 信息

  GET_SMS_VALIDATE: '/api/user/getSmsCodeLogin',      // 获取短信验证码

  ENTER_CARD_IDENTIFY: '/api/contest/enter/card/identify',      // 上传证件获取信息

  // 智能客服接口
  GET_USER_SIG: '/api/im/user/getUserSig',                          //

  TALK_GET_HISTORY_LIST: '/api/v3/customer/talk/getHistoryList',                      // 获取聊天记录(学生端)

  TALK_GET_TOP5: '/api/v3/customer/talk/getTopFiveQuestion',                      // 获取Top5提问(学生端)

  TALK_SEND_MSG: '/api/v3/customer/talk/sendMsg',                      // 发送消息(学生端)

  TALK_GET_QUESTION_INFO: '/api/v3/customer/talk/getQuestionInfo',                      // 发送获取问题详情(学生端)

  TALK_STATUS_MARK: '/api/v3/customer/talk/statusMark',                     // 标记状态(学生端)

  TALK_GETUSER_SIGN: '/api/v3/customer/talk/getImUserSign'                     // 获取im用户签名
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/user.js